import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { getUserInfo } from "../../services/AuthService";
import { fetchCurrentUser, ROLE_LABEL } from "../../services/UserAdminService";

function AdminLayout() {
    const navigate = useNavigate();
    const cachedUser = getUserInfo() || {};
    const [role, setRole] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const res = await fetchCurrentUser();
                if (!cancelled) setRole(res?.data?.role);
            } catch {
                /* ignore */
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("user");
        navigate("/login");
    };

    const initial = (cachedUser.username || cachedUser.email || "A")
        .charAt(0)
        .toUpperCase();

    return (
        <div
            className="w-full bg-[#f7f7f8] flex"
            style={{ height: "100dvh", maxHeight: "100dvh" }}
        >
            {/* Sidebar */}
            <aside className="w-[260px] shrink-0 bg-white border-r border-gray-200 flex flex-col">
                <div className="px-5 py-4 border-b border-gray-100 flex items-center gap-2">
                    <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-red-600 to-red-700 flex items-center justify-center text-white text-sm font-bold">
                        π
                    </div>
                    <div className="min-w-0">
                        <div className="text-sm font-semibold text-gray-900 leading-tight truncate">
                            PIMATH Admin
                        </div>
                        <div className="text-[11px] text-gray-500 leading-tight">
                            Bảng điều khiển
                        </div>
                    </div>
                </div>

                <nav className="flex-1 overflow-y-auto px-3 py-3 space-y-1">
                    <NavLink
                        to="/admin-chatbot-ai/users"
                        className={({ isActive }) =>
                            `flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${isActive
                                ? "bg-red-50 text-red-700 font-semibold"
                                : "text-gray-700 hover:bg-gray-100"
                            }`
                        }
                    >
                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.8}
                                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                            />
                        </svg>
                        Quản lý User
                    </NavLink>

                    <a
                        href="/chatbot-ai"
                        className="flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-gray-700 hover:bg-gray-100 transition-colors"
                    >
                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.8}
                                d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
                            />
                        </svg>
                        Chatbot
                    </a>
                </nav>

                <div className="border-t border-gray-100 p-3">
                    <div className="flex items-center gap-3 px-2 py-2">
                        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-red-600 to-red-700 flex items-center justify-center text-white text-sm font-semibold">
                            {initial}
                        </div>
                        <div className="min-w-0 flex-1">
                            <div className="text-sm font-medium text-gray-900 truncate">
                                {cachedUser.username || "Admin"}
                            </div>
                            <div className="text-[11px] text-gray-500 truncate">
                                {role !== null
                                    ? ROLE_LABEL[role] || `Role ${role}`
                                    : cachedUser.email}
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={handleLogout}
                        className="mt-1 w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-gray-600 hover:bg-gray-100 transition-colors"
                    >
                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={1.8}
                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H6a2 2 0 01-2-2V7a2 2 0 012-2h5a2 2 0 012 2v1"
                            />
                        </svg>
                        Đăng xuất
                    </button>
                </div>
            </aside>

            {/* Main */}
            <main className="flex-1 min-w-0 min-h-0 overflow-hidden flex flex-col">
                <Outlet />
            </main>
        </div>
    );
}

export default AdminLayout;
